import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Route, Redirect, Switch } from 'react-router-dom';
import { useTheme, useMediaQuery } from '@material-ui/core';
import { AllLeadMagnetsPage, ArchivedLeadMagnetsPage } from 'pages/LeadMagnetView';
import MainContainer from './MainContainer';
import { useSelector } from 'react-redux';

const StyledMainSection = styled.div`
  padding: ${({ mobileView, showIntroPage }) => (mobileView ? '30px 5px' : showIntroPage ? '16px' : '30px 55px')};
`;

function LeadMagnetsContainer({ match: { path } }) {
  const theme = useTheme();
  const mobileView = useMediaQuery(theme.breakpoints.down('sm'));
  const { leadMagnetsCollection } = useSelector(s => s.leadMagnets);
  const showIntroPage = !leadMagnetsCollection || leadMagnetsCollection?.length === 0;

  return (
    <MainContainer>
      <StyledMainSection mobileView={mobileView} showIntroPage={showIntroPage}>
        <Switch>
          <Route path={`${path}/all`} exact component={AllLeadMagnetsPage} />
          <Route path={`${path}/archived`} exact component={ArchivedLeadMagnetsPage} />
          <Redirect to={`${path}/all`} />
        </Switch>
      </StyledMainSection>
    </MainContainer>
  );
}

LeadMagnetsContainer.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string,
    url: PropTypes.string,
    isExact: PropTypes.bool,
    params: PropTypes.object,
  }).isRequired,
};

export default LeadMagnetsContainer;
